import { Icon, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { IVStackProps } from 'native-base/lib/typescript/components/primitives/Stack/VStack';
import React, { useCallback } from 'react';
import { Pressable } from 'react-native';

import { TableContent, TableContentItemColumn } from '../../../../../../../components/TableContent';
import { useWithValueVisibility } from '../../../../../../../hooks/useWithValueVisibility';
import { getFlex } from '../utils';

import { InvestmentStrategyItemTypes } from './types';

const defaultVStackProps: IVStackProps = {
  space: Spacing['stack.quarck'],
  flex: 1,
};

export const InvestmentStrategyItemMobile: React.FC<InvestmentStrategyItemTypes.Props> = ({
  item,
}) => {
  const withValueVisibility = useWithValueVisibility();
  const [expanded, setExpanded] = React.useState(false);

  const toggleExpand = useCallback(() => {
    setExpanded((state) => !state);
  }, []);

  return (
    <TableContent
      direction="row"
      space={0}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}
      flexWrap="wrap">
      <TableContentItemColumn flex={getFlex(0)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Data</Text>
          <Text>{withValueVisibility(item.positionDateNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <VStack {...defaultVStackProps}>
          <Text variant="bold">Cliente</Text>
          <Text>{withValueVisibility(item.customerNameNormalized)}</Text>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex="none">
        <Pressable onPress={toggleExpand}>
          <Icon name={expanded ? 'ChevronUp' : 'ChevronDown'} size="xs" />
        </Pressable>
      </TableContentItemColumn>
      {expanded && (
        <VStack
          padding={Spacing['inset.xs']}
          space={Spacing['stack.nano']}
          marginTop={Spacing['inline.xxxs']}
          borderRadius={BoxRadius.sm}
          backgroundColor={Color.background}
          width="100%">
          <HStack justifyContent="space-between">
            <Text>Conta de custódia</Text>
            <Text>{withValueVisibility(item.customerCustodyAccountNumberNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Conta Sinacor</Text>
            <Text>{withValueVisibility(item.customerAccountNumberNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>CPF/CNPJ</Text>
            <Text>{withValueVisibility(item.customerCpfOrCnpjNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Nome do assessor</Text>
            <Text>{withValueVisibility(item.advisorNameNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Filial</Text>
            <Text>{withValueVisibility(item.branchNameNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Produto</Text>
            <Text>{withValueVisibility(item.productNameNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Classe</Text>
            <Text>{withValueVisibility(item.productClassNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Quantidade</Text>
            <Text>{withValueVisibility(item.quantity)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Valor PU</Text>
            <Text>{withValueVisibility(item.unitPriceNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Data PU</Text>
            <Text>{withValueVisibility(item.positionDateNormalized)}</Text>
          </HStack>
          <HStack justifyContent="space-between">
            <Text>Valor produto</Text>
            <Text>{withValueVisibility(item.positionValueNormalized)}</Text>
          </HStack>
        </VStack>
      )}
    </TableContent>
  );
};
